/*eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Button, Card, Row, Col } from 'react-bootstrap';
import FilterModal from '../../../common/filter-modal/FilterModal';
import { CoverageHistory } from './coverageHistory';
import coverageData from './coverageHistory.json';
import { insertSpaces } from '../../../../utils/strings';
//import CustomClientError from '../../../../../Member/errorhandling/CustomClientError';
import useDate from '../../../../utils/useDate';
import PlanDetailsForOthersSkeleton from '../coverage-details/skeleton/PlanDetailsForOthersSkeleton';
import Feature from '../../../../../services/feature';
import DownloadDocumentModal from './DownloadDocumentModal/DownloadDocumentModal';
import MasterPermissions from '../../../../api/MasterPermissions';
import httpheader from 'src/Admin/shared/httpheader';

export const PlanDetailsForOthers = (PlanInfo) => {
  const [isOpenCoveragePopup, setIsOpenCoveragePopup] = useState(false);
  const [isOpenDownloadDocumentPopup, setisOpenDownloadDocumentPopup] =
    useState(false);
  const showCancel = false;
  const titleLabel = 'Coverage History';
  const showApply = true;
  const showApplyLabel = 'CLOSE';
  //const isAPIFailed=PlanInfo?.isAPIFailed;
  //const isNotFound=PlanInfo?.isNotFound;
  const dataFetching = PlanInfo?.dataFetching;
  const activeCoverageType = PlanInfo?.activeCoverageType;
  const activeMemType = PlanInfo?.activeMemType;
  //const planDetails=PlanInfo.planDetails;
  const coverageData = PlanInfo.coverageData;
  const coverageDetails = PlanInfo?.planDetails;
  const memberCoverageDetails = PlanInfo?.planDetails.MemberCoverage;
  const lastIndex = coverageData?.length;
  const data = memberCoverageDetails?.find(
    (plans) => insertSpaces(plans.Product) === activeCoverageType,
  );

  console.log('PlanInfo', data);
  const { formatDate } = useDate();
  const applyFilterHandler = () => {
    setIsOpenCoveragePopup(false);
  };

  return (
    <>
      {dataFetching ? (
        <PlanDetailsForOthersSkeleton />
      ) : (
        <Card className="plan-card">
          <Row>
            <Col xs={4}>
              {data?.BenefitPlan && (
                <div className="plan-card-space">
                  <label className="plan-details-lable-other">
                    Benefit Plan
                  </label>
                  <span className="plan-details-data-other">
                    {data?.BenefitPlan}
                  </span>
                </div>
              )}
              <div className="plan-card-space">
                <label className="plan-details-lable-other">
                  Coverage Status
                </label>
                <span className="plan-details-data-other">
                  {' '}
                  {coverageDetails.Status}
                </span>
              </div>
              <div className="plan-card-space">
                <label className="plan-details-lable-other">
                  Coverage Period
                </label>
                <span className="plan-details-data-other">
                  {' '}
                  {formatDate(coverageDetails?.EffectiveDate)} - Current
                </span>
              </div>
            </Col>
            <Col xs={4}>
              <div className="plan-card-space">
                <label className="plan-details-lable-other">
                  Coverage Effective From
                </label>
                <span className="plan-details-data-other">
                  {' '}
                  {formatDate(coverageData[lastIndex - 1]?.EffectiveDate)}
                </span>
              </div>
              {/*<div className="plan-card-space">
                    <label className="plan-details-lable-other"> Coverage Level</label>
                    <span className="plan-details-data-other"> {data?.CoveredMembers|| 'NA'}</span>
                  </div> */}
              <p className="text-left p-0">
                <label
                  className="view-coverage-summary1"
                  onClick={() => {
                    setIsOpenCoveragePopup(true);
                  }}
                >
                  View Coverage History
                </label>
              </p>
            </Col>
            {MasterPermissions.CheckPermission('Download Plan Document') && (
              <Col xs={4} className="p-top-10">
                <div className="button-card">
                  {data?.MasterId && (
                    <Button
                      bsPrefix="download-plan-document-button"
                      onClick={() => {
                        setisOpenDownloadDocumentPopup(true);
                      }}
                    >
                      <span className="download-plan-document-text">
                        {httpheader.getCNAME().includes('keenan') ||
                        httpheader.getCNAME().includes('tpabenefits')
                          ? 'Download Benefit Documents'
                          : 'Download Plan Documents'}
                      </span>
                    </Button>
                  )}
                </div>
              </Col>
            )}
          </Row>
          <FilterModal
            isVisible={isOpenCoveragePopup}
            onHide={() => {
              setIsOpenCoveragePopup(false);
            }}
            applyFilterHandler={applyFilterHandler}
            showCancel={showCancel}
            titleLabel={titleLabel}
            showApply={showApply}
            showApplyLabel={showApplyLabel}
          >
            <CoverageHistory
              coverageData={coverageData}
              activeMemType={activeMemType}
              {...PlanInfo}
            />
          </FilterModal>
          {data?.MasterId && (
            <DownloadDocumentModal
              isVisible={isOpenDownloadDocumentPopup}
              onHide={() => {
                setisOpenDownloadDocumentPopup(false);
              }}
              showApply={showApply}
              showApplyLabel={showApplyLabel}
              activeCoverageType={activeCoverageType}
              MasterID={data?.MasterId}
            />
          )}
        </Card>
      )}
    </>
  );
};
